module.exports = __webpack_public_path__ + "img/TheMix_cls_TT5_.fd56f9eb.svg";